import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Article } from './components/stack/views/Article/Article';
import { ArticlePropsProvider } from './components/stack/hooks/content/useArticleProps';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('content-hub');
  if (!container) return drawDefaultLayout();
  const root = createRoot(container);

  root.render(
    <BaseContentProvider>
      <ArticlePropsProvider>
        <DefaultLayout>
          <Article />
        </DefaultLayout>
      </ArticlePropsProvider>
    </BaseContentProvider>
  );
});
